import DOMPurify from "dompurify"

export function sanitizeHtml(html: string): string {
  return DOMPurify.sanitize(html)
}

export function dangerousInnerHtmlObj(html: string | undefined): {
  __html: string
} {
  if (!html) {
    return { __html: "" }
  }
  return { __html: sanitizeHtml(html) }
}
